import { makeStyles } from 'tss-react/mui';

import { chipClasses } from '@mui/material';

export default makeStyles<void, 'icon' | 'text' | 'label' | 'button' | 'date' | 'disabled'>({
    name: 'RevisionSelect'
})((_, __, classes) => ({
    chip: {
        minHeight: 42,
        maxHeight: 42,
        borderRadius: 12,
        gap: 8,
        padding: '12px 16px',
        border: '1px solid #ECECEC',
        boxShadow: 'none !important',
        backgroundColor: 'inherit !important',
        [`& .${chipClasses.label}`]: {
            flex: 1,
            padding: 0
        },
        [`& .${classes.icon}`]: {
            color: '#232323',
            width: 16,
            height: 16,
            margin: 0
        },
        [`& .${classes.text}`]: {
            color: '#2D2D2D',
            fontSize: 13,
            fontWeight: 500,
            lineHeight: '100%',
            letterSpacing: -0.25,
            opacity: 0.7
        },
        [`& .${classes.label}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flex: 1,
            gap: 8
        },
        [`& .${classes.date}`]: {
            color: '#2D2D2D',
            fontSize: 13,
            fontWeight: 500,
            lineHeight: '100%',
            letterSpacing: -0.25
        },
        [`&.${classes.disabled}`]: {
            background: '#f8f8f8',
            borderColor: '#f8f8f8',
            [`& .${classes.text}`]: {
                color: '#8E8E8E'
            },
            [`& .${classes.label}`]: {
                color: '#8E8E8E'
            },
            [`& .${classes.icon}`]: {
                color: '#8E8E8E'
            }
        }
    },
    icon: {},
    text: {},
    label: {},
    date: {},
    disabled: {},
    button: {},
    menu: {
        position: 'relative',
        minWidth: 320,
        maxWidth: 380,
        maxHeight: 600,
        paddingLeft: 4,
        paddingRight: 4,
        marginTop: 4,
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    menuList: {
        paddingTop: 0
    },
    menuTitle: {
        zIndex: 100,
        textTransform: 'uppercase',
        paddingTop: 8,
        paddingBottom: 8,
        top: 0,
        position: 'sticky',
        background: '#fff',
        color: '#8E8E8E',
        fontSize: 10,
        fontWeight: 600,
        lineHeight: '16px',
        letterSpacing: 1,
        paddingLeft: 12,
        paddingRight: 12
    },
    empty: {
        paddingLeft: 12
    },
    spinner: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    download: {
        position: 'sticky',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        bottom: 8,
        [`& .${classes.button}`]: {
            boxShadow: 'none !important',
            background: '#232323',
            color: '#fff',
            ['&:hover']: {
                background: '#2D2D2D'
            },
            ['&:active']: {
                background: '#151515'
            },
            ['&:disabled']: {
                background: '#FAFAFA',
                color: '#D3D3D3'
            }
        }
    }
}));
